export default {
  namespaced: true,
  state() {
    return {
      clickApi: false,
      agreeApi: false,
      deleteApi: false,
      regEx:"",
      regApi:"",
      regSecret:"",
      regPass:"",
      edit:false,
    };
  },
  mutations: {
    changeApi(state, payload) {
      state.clickApi = payload.state;
    },
    changeAgree(state, payload) {
      state.agreeApi = payload.state;
    },
    changeDelete(state, payload) {
      state.deleteApi = payload.state;
    },
    changeEdit(state, payload) {
      // console.log(payload);
      state.edit = payload.state;
    },
    setEx(state,payload){
      // console.log(payload);
      state.regEx = payload.exchange;
    },
    setApiKey(state,payload){
      state.regApi = payload.api;
    },
    setSecretKey(state,payload){
      state.regSecret = payload.secret;
    },
    setPassKey(state,payload){
      state.regPass = payload.pass;
    },
  },
  actions: {},
};
